import React from 'react';

import {Button, Icon, Text} from '@albert-io/atomic';
import {EmptyState, EmptyIllustration} from 'client/TeacherDashboard/components/EmptyState';
import {NoSearchResults} from 'client/TeacherDashboard/components/NoSearchResults';
import {history} from 'client/history';

import {ADAPTIVE_SUBJECTS_PATH, STATUS_SEGMENTS} from './constants';
import type {SkillPathStatusSegment} from './types';

const SKILL_PATH_ILLUSTRATION = (
  <EmptyIllustration badgeClassName='background-special-subtle content-special' icon='sparkles' />
);

export const SkillPathsOnboardingEmptyState = ({
  primarySubjectName = 'Adaptive Math',
  primarySubjectPath = ADAPTIVE_SUBJECTS_PATH
}: {
  primarySubjectName?: string;
  primarySubjectPath?: string;
}) => (
  <EmptyState
    action={
      <div className='gap-x1 flex flex-wrap items-center justify-center'>
        <Button roundness='pill' onClick={() => history.pushState(null, primarySubjectPath)}>
          {primarySubjectName}
          <Icon className='ml-x1' icon='arrow-right' iconStyle='regular' />
        </Button>
        <Button
          color='secondary'
          roundness='pill'
          variant='outlined'
          onClick={() => history.pushState(null, ADAPTIVE_SUBJECTS_PATH)}
        >
          View All Adaptive
        </Button>
      </div>
    }
    illustration={SKILL_PATH_ILLUSTRATION}
  >
    <div className='gap-x1 flex flex-col'>
      <Text as='div' bold size='l'>
        No Skill Paths
      </Text>
      <Text as='div' className='max-w-[440px]' color='secondary'>
        Send skills from an adaptive subject to build a skill path for your students.
      </Text>
    </div>
  </EmptyState>
);

/** Scope has skill paths, but the active status tab has none. */
export const SkillPathStatusEmptyState = ({segment}: {segment: SkillPathStatusSegment}) => {
  const label = STATUS_SEGMENTS.find((s) => s.value === segment)?.label ?? '';
  return (
    <EmptyState illustration={SKILL_PATH_ILLUSTRATION}>
      <Text as='div' size='l'>
        No {label} Skill Paths
      </Text>
    </EmptyState>
  );
};

export const SkillPathsFilteredEmptyState = () => <NoSearchResults />;
